import { supabase } from "@/integrations/supabase/client";
import { Session } from "@supabase/supabase-js";

/**
 * Gets a fresh session, attempting to refresh if the current one is stale.
 * This is more reliable than just getSession() which can return cached tokens.
 */
export async function getFreshSession(): Promise<Session | null> {
  // First try to get current session
  const { data: { session }, error: sessionError } = await supabase.auth.getSession();
  
  if (sessionError || !session) {
    console.error("No session found:", sessionError);
    return null;
  }
  
  // Check if the access token is close to expiring (within 60 seconds)
  const expiresAt = session.expires_at;
  const now = Math.floor(Date.now() / 1000);
  const isExpiringSoon = expiresAt && (expiresAt - now) < 60;
  
  if (isExpiringSoon) {
    console.log("Session expiring soon, refreshing...");
    // Force a token refresh
    const { data: { session: refreshedSession }, error: refreshError } = 
      await supabase.auth.refreshSession();
    
    if (refreshError || !refreshedSession) {
      console.error("Failed to refresh session:", refreshError);
      // Return null to signal that re-login is needed
      return null;
    }
    
    console.log("Session refreshed successfully");
    return refreshedSession;
  }
  
  return session;
}
